import React from "react";
import { ArrowRight, Phone } from "lucide-react";
import { Link } from "react-router-dom";
import { Container } from "./Container";
import { Reveal } from "./Reveal";
import { QButton } from "./QButton";
import { CTA_BAND, CONTACT } from "../../lib/content";

export const CTABand = ({ testId = "section-cta", primaryHref = "/contact" }) => (
  <section
    id="cta"
    data-testid={testId}
    className="bg-white border-t border-border"
  >
    <Container className="py-24 md:py-32">
      <Reveal>
        <div className="max-w-3xl">
          <div className="qv-eyebrow text-brand-blue mb-5">{CTA_BAND.eyebrow}</div>
          <h2 className="qv-h2-display" data-testid="cta-headline">
            {CTA_BAND.headline}
          </h2>
          <p className="qv-lead mt-6 max-w-[55ch]">{CTA_BAND.body}</p>
          <div className="mt-9 flex flex-wrap gap-3">
            <QButton
              variant="primary"
              size="lg"
              as={Link}
              to={primaryHref}
              iconRight={ArrowRight}
              data-testid="cta-primary"
            >
              {CTA_BAND.primary}
            </QButton>
            <QButton
              variant="outline-blue"
              size="lg"
              as="a"
              href={`tel:${(CONTACT.phone || "").replace(/\s/g, "")}`}
              icon={Phone}
              data-testid="cta-secondary"
            >
              {CTA_BAND.secondary}
            </QButton>
          </div>
        </div>
      </Reveal>
    </Container>
  </section>
);

export default CTABand;
